import type { ApiResponse } from 'ts/interfaces/api-response.interface';
import fetchApi from 'utils/api-utils';
import { getProps } from 'utils/global-utils';

const GET_DISTANCE_FOR_MOBILITY_URL =
  process.env.REACT_APP_SYNERGY_GET_DISTANCE_FOR_MOBILITY_URL;

export const getDistanceForMobility = async ({
  body,
  moveVersion,
  partner,
  tenantId,
  token,
}: any): Promise<ApiResponse<any>> => {
  const rs = await fetchApi(GET_DISTANCE_FOR_MOBILITY_URL, {
    method: 'POST',
    body,
    headers: {
      'Content-Type': 'application/json',
      'x-env': process.env.REACT_APP_ABODE_ENV,
      'x-partner': partner,
      'x-provider': moveVersion,
      'x-requested-by': 'synergy',
      'x-tenant-id': tenantId,
      'x-token': token,
    },
  });
  const data = getProps(rs, 'json') && (await rs.json());
  return { status: rs.status, ok: rs.ok, result: data };
};

export default getDistanceForMobility;
